import React from 'react';
import styled from '@emotion/styled';
import { PreviewProps } from '../../LandingPagePreview';
import MobileHeader from '../Shared/MobileHeader';
import Breathing from '~/App/Components/Shared/Breathing';
import Logo from '../Shared/Logo';
import { assetUrl } from '~/helpers';
import VideoPlayerPreview from '../Shared/VideoPlayerPreview';
import UserProfile from '../Shared/UserProfile';
import MessageContent from '../Shared/MessageContent';
import { BonjoroBadgeMobile } from '~/App/Components/BonjoroBadgeMobile';
import LayoutPreview from '../Components/LayoutPreview';

const VideoPlayerPreviewWrapper = styled.div`
  position: relative;
  width: 15em;
  height: 15em;
  margin: 0 auto;
`;

const MessageSpace = styled.div`
  margin: 0 13px;
`;

const Title = styled.span`
  display: block;
  font-size: 12px;
`;

const SubTitle = styled.span`
  display: block;
  font-size: 10px;
`;

const ContentHeader = styled.div`
  position: relative;
`;

const ShareBtnImage = styled.img`
  max-width: 60%;
  max-height: 60%;
  opacity: 0.6;
`;

const ShareBtnWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 10px;
  width: 32px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  border-radius: 50%;
  box-shadow: rgb(0 0 0 / 25%) 0px 2px 8px;
  cursor: pointer;
  z-index: 1600;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Postcard = (props: PreviewProps) => {
  const {
    userName,
    highlight,
    logoUrl,
    showBonjoroBadge,
    playerImage,
    userImage,
    userShortName,
    message,
    secondaryColor,
    ctaText,
    ctaUrl,
    showCta,
    color,
    showSocialSharing,
  } = props;

  return (
    <>
      <MobileHeader>
        <Title>{userName}</Title>
        <SubTitle>bonjoro.com</SubTitle>
      </MobileHeader>
      <ContentHeader>
        <Breathing
          active={highlight === 'logo'}
          componentClass={Logo}
          logoUrl={logoUrl}
        />
        {showSocialSharing && (
          <ShareBtnWrapper>
            <ShareBtnImage src={assetUrl('assets/images/icons/ic_share.svg')} />
          </ShareBtnWrapper>
        )}
      </ContentHeader>
      <VideoPlayerPreviewWrapper>
        {showBonjoroBadge && (
          <BonjoroBadgeMobile
            className='absolute top-0 left-0 z-[105]'
            cssStyle={{
              zoom: '0.6',
            }}
          />
        )}
        <VideoPlayerPreview playerImage={playerImage || ''} mode='cover' />
      </VideoPlayerPreviewWrapper>
      <UserProfile userImage={userImage} userName={userName} />
      <MessageSpace>
        <MessageContent
          mode='compact'
          userShortName={userShortName}
          message={message}
          highlight={highlight}
          ctaText={ctaText}
          secondaryColor={secondaryColor}
          ctaUrl={ctaUrl}
          showCta={showCta}
          color={color}
        />
      </MessageSpace>
      <LayoutPreview />
    </>
  );
};

export default Postcard;
